import { multiply as multiplyUnit } from '../units';

export const spacer = ({ theme }) => theme.spacer;

export const multiply = (base = '1rem', multiplier = 1) => ({ theme }) => {
  const parsedBase = typeof base === 'function' ? base({ theme }) : base;
  const parsedMultiplier = typeof multiplier === 'function' ? multiplier({ theme }) : multiplier;
  return multiplyUnit(parsedBase, parsedMultiplier);
};
